import React from "react";
import { Header } from "components";
import { ConsumptionCalculation } from "view";

export const App = () => {
  return (
    <>
      <Header />
      <ConsumptionCalculation />
    </>
  );
};

export default App;
